import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { OpenCallWithoutRegisterComponent } from 'src/app/components/open-call-without-register/open-call-without-register.component';

@Component({
  selector: 'app-client-login',
  templateUrl: './client-login.component.html',
  styleUrls: ['./client-login.component.scss']
})
export class ClientLoginComponent implements OnInit {
  public loginForm: UntypedFormGroup;
  public _loading: boolean = false;
  public _error: boolean = false;

  constructor(
    public fb: UntypedFormBuilder,
    private auth: AuthService,
    private router: Router,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      email: [undefined, [Validators.required, Validators.email]],
      passwd: [undefined, [Validators.required]]
    });
  }

  public openCallWithoutRegister() {
    this.dialog.open(OpenCallWithoutRegisterComponent, {
      width: "500px"
    });
  }

  public makeLogin() {
    this._loading = true
    this.auth.login(
      this.loginForm.value.email,
      this.loginForm.value.passwd
    )
      .toPromise()
      .then((value) => {
        this.auth.logUserIn(value);
        this._loading = false
        this.router.navigate(['/cliente'])
      })
      .catch(() => {
        this._loading = false
        this._error = true
        this.loginForm.controls['email'].setErrors({'incorrect': true});
        this.loginForm.controls['passwd'].setErrors({'incorrect': true});
      });
  }

}
